/**
 * Created by Denis Kuzin on 08 august 2024
 */

var MarkComponent = function (cell) {
    this.cell = cell;

    this.mark = undefined;
};

MarkComponent.prototype.addMark = function (mark) {
    this.mark = mark || new Mark(this.cell);
};

MarkComponent.prototype.removeMark = function () {
    this.mark = undefined;
};

MarkComponent.prototype.explode = function () {
    if (this.mark) {
        this.mark.explode();
        this.mark = undefined;
    }
};

MarkComponent.prototype.smile = function () {
    if (this.mark) {
        this.mark.smile();
    }
};

MarkComponent.prototype.repaint = function (cell) {
    var markComponent = cell.findComponent(MarkComponent);

    if (markComponent) {
        if (markComponent.mark) {
            this.addMark();
        }
    }

    return this.cell;
};

MarkComponent.prototype.load = function (data) {
    if (data.includes(Mark.CODES[0])) {
        this.addMark();
    }
};

MarkComponent.prototype.save = function () {
    if (this.mark) {
        return this.mark.code;
    }
};
